import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const EIDSIndex = () => {
  const navigate = useNavigate();

  const eids = async () => {
    navigate(`/admin/panel?activePanelMenu=adManagement&currentStep=0`);
  };

  useEffect(() => {
    eids();
  }, []);

  return <></>;
};

export default EIDSIndex;
